import type { FaireProductEntity } from "../../entity_types/product";

export const p_ut8jmvuw74: FaireProductEntity = {
  token: "p_ut8jmvuw74",
  type: "product",
  name: "Elderberry Healer Organic Herbal Tea Sachets",
  brandToken: "b_9jd96k047p",
  brandName: "Rishi Tea & Botanicals",
  imageUrl:
    "https://cdn.faire.com/fastly/490351ed1ce53889c4c4f0607af60e0c747caee6e2ff861eecf0225572c9604c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5c71c9e3bb29017931e34ebca1853dfe560a72d1113d7cad02d08502534e5f7e.png",
    "https://cdn.faire.com/fastly/a9272c3f0350502fc38c3f8888edd25b8ef43f6ff107ed694b9001cf5bf28df2.jpeg",
    "https://cdn.faire.com/fastly/915d66e9939519484c714acdbd6340f884ed6df41385eea0451f612118d40caf.jpeg",
    "https://cdn.faire.com/fastly/b92d5a480c279d5fe603ba655e186fe220ab09779d88418df73f47a9c3988074.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "This item comes in a case of 6 retail-ready boxes of 15 sachets.\n\nThis soothing botanical blend has a rich, cordial-like flavor that highlights sumptuous elderberry. Elderberry has been used for ages in folk herbal remedies. Warming ginger and replenishing hibiscus help to fortify the blend. A touch of licorice root lends a hint of natural sweetness that balances the ginger spice.\n\nTASTING NOTES\nA rich cup highlighting the cordial like body and immune-boosting elderberry balanced with ginger and licorice root.\n\nCAFFEINE LEVEL\nNone",
  tags: [],
  msrpDollars: 13.86,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:25.017Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
